/** « à l'instant », « il y a 5 min », « il y a 2 h », puis le jour à La Réunion : l'heure d'un message. */
export function momentRelatif(iso: string, maintenant: Date = new Date()): string {
  const instant = new Date(iso);
  const minutes = Math.floor((maintenant.getTime() - instant.getTime()) / 60_000);
  if (minutes < 1) return 'à l’instant';
  if (minutes < 60) return `il y a ${minutes} min`;
  if (minutes < 24 * 60) return `il y a ${Math.floor(minutes / 60)} h`;
  return `le ${instant.toLocaleDateString('fr-FR', { timeZone: 'Indian/Reunion', day: 'numeric', month: 'short' })}`;
}
